<script setup>
</script>

<template>
    <div class=".surface-ground flex align-items-center justify-content-center overflow-hidden">
        <div class="flex flex-column align-items-center justify-content-center">
            <div class="w-full .surface-card py-4 px-8 sm:px-8 flex flex-column align-items-center border-round-xl">
                <div class="grid flex flex-column align-items-center mt-2">
                    <div class="flex justify-content-center align-items-center bg-blue-500 border-circle"
                        style="height: 3.2rem; width: 3.2rem">
                        <i class="pi pi-fw pi-exclamation-circle text-2xl text-white"></i>
                    </div>
                    <h1 class="text-900 font-bold text-3xl mb-2 text-center">{{ $t('EMPTY') }}</h1>
                    <span class="text-900 mb-5 text-center"> {{ $t('NOSOONPERATION') }}</span>

                </div>
            </div>
        </div>
    </div>
</template>
